import React from 'react';
import { AccentHR } from 'scy/HR';
import { H6 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

function Aside({ asideTitle, asideBody, anchorTagText }) {
  return (
    <aside className={styles.aside}>
      <H6 uppercase marginClass={margin.bottom_sm}>
        {asideTitle}
      </H6>
      <AccentHR className={margin.bottom_md} />
      <p>{asideBody}</p>
      <a href="mailto:support@saucey.com">{anchorTagText || ''}</a>
    </aside>
  );
}

export default Aside;
